export function createResume(allWorkItems, resume, forWebsite = false) {
  const jsonResume = {
    basics: createBasics(resume),
    work: createWorkItem(allWorkItems, resume, forWebsite),
    education: createEducation(resume),
    skills: createSkills(resume),
    languages: [
      {
        name: "English",
        level: "Native speaker"
      }
    ]
  };
  return jsonResume;
}

function createBasics(resume) {
  const location = resume.slices.location[0].primary;
  return {
    name: resume.name,
    label: resume.label,
    picture: resume.picture.url,
    email: resume.email,
    phone: resume.phone,
    website: resume.website.url,
    summary: resume.summary,
    location: {
      address: location.address,
      postalCode: location.postalcode,
      city: location.city,
      countryCode: location.countrycode,
      region: location.region
    },
    profiles: resume.slices.profiles[0].items.map(item => {
      return {
        network: item.network,
        url: item.url.url,
        username: item.username
      };
    })
  };
}

function createWorkItem(allWorkItems, resume, forWebsite) {
  const workItems = resume.slices.work.map(workItem => {
    const primary = workItem.primary;
    if (!forWebsite) {
      return {
        company: primary.company,
        position: primary.position,
        website: primary.companyWebsite.url,
        startDate: primary.startdate,
        endDate: primary.enddate,
        summary: primary.companySummary,
        highlights: createHighlights(allWorkItems, workItem)
      };
    }
    return hasWebLinkedHighlights(allWorkItems, workItem)
      ? {
          company: primary.company,
          position: primary.position,
          website: primary.companyWebsite.url,
          startDate: primary.startdate,
          endDate: primary.enddate,
          summary: primary.companySummary,
          highlights_with_links: createHighlightsWithLinks(
            allWorkItems,
            workItem
          )
        }
      : {
          company: primary.company,
          position: primary.position,
          website: primary.companyWebsite.url,
          startDate: primary.startdate,
          endDate: primary.enddate,
          summary: primary.companySummary,
          highlights: createHighlights(allWorkItems, workItem)
        };
  });
  return workItems;
}

function createEducation(resume) {
  return resume.slices.education.map(education => {
    const items = education.items;
    const primary = education.primary;
    return {
      institution: primary.institution,
      area: primary.area,
      studyType: primary.studytype,
      startDate: primary.startdate,
      endDate: primary.enddate,
      gpa: primary.gpa,
      courses: items.map(item => item.courses).filter(item => item !== null)
    };
  });
}

function createSkills(resume) {
  return resume.slices.skills.map(skill => {
    return {
      name: skill.primary.skillName,
      level: skill.primary.level,
      keywords: skill.items.map(item => item.keyword)
    };
  });
}

function createHighlights(allWorkItems, workItem) {
  const highlights = workItem.items;
  return highlights.map(highlight => {
    let workingHighlight;
    if (highlight.workItem) {
      const fullWorkItem = allWorkItems.find(
        workItem => workItem.id === highlight.workItem.id
      );
      if (fullWorkItem) {
        const title = fullWorkItem.title;
        const content = fullWorkItem.highlight[0].text;
        const url = fullWorkItem.url.url ? fullWorkItem.url.url.replace(/\/$/, "") : "(WIP)";
        workingHighlight = `${title} @ ${url}: ${content}`;
      } else if (highlight.highlight[0]) {
        workingHighlight = highlight.highlight[0].text;
      }
    } else if (highlight.highlight[0]) {
      workingHighlight = highlight.highlight[0].text;
    }
    return workingHighlight;
  });
}

function createHighlightsWithLinks(allWorkItems, workItem) {
  const highlights = workItem.items;
  return highlights
    .map(highlight => {
      if (highlight.workItem) {
        const fullWorkItem = allWorkItems.find(
          workItem => workItem.id === highlight.workItem.id
        );
        if (fullWorkItem) {
          const title = fullWorkItem.title;
          const content = fullWorkItem.highlight[0] ? fullWorkItem.highlight[0].text : fullWorkItem.highlight;
          const url = fullWorkItem.url.url ? fullWorkItem.url.url : null;
          return {
            website: url,
            title: title,
            content: content
          };
        }
      } else if (highlight.highlight[0]) {
        return {
          website: url,
          title: title,
          content: highlight.highlight[0].text
        };
      }
    })
    .filter(workItem => workItem !== undefined);
}

function hasWebLinkedHighlights(allWorkItems, workItem) {
  const highlights = workItem.items;
  return (
    highlights
      .map(highlight => {
        if (highlight.workItem) {
          const fullWorkItem = allWorkItems.find(
            workItem => workItem.id === highlight.workItem.id
          );
          if (!fullWorkItem) return;
          return true;
        }
      })
      .filter(workItem => workItem !== undefined).length !== 0
  );
}